import PageHero from "@/components/PageHero";
import CTASection from "@/sections/CTASection";
import { Quote, Award, Briefcase, GraduationCap } from "lucide-react";
import { BRAND } from "@/data/site";
import FOUNDER_PHOTO from "@/assets/Founder_2.png";

const ACHIEVEMENTS = [
  { icon: Award, label: "20+ Years of leadership across consultancy and infrastructure" },
  { icon: Briefcase, label: "₹2,800Cr+ in advised project value across India" },
  { icon: GraduationCap, label: "B.E. Civil Engineering, MBA in Strategic Management" },
];

export default function Founder() {
  return (
    <div data-testid="founder-page">
      <PageHero
        overline="Founder"
        title={<>T G Dey<br /><span className="italic font-light text-gold">Founder &amp; Managing Director</span></>}
        subtitle="A founder-led practice, anchored in two decades of engineering, hospitality and infrastructure experience across India."
        image={FOUNDER_PHOTO}
        breadcrumbs={[{ label: "Founder" }]}
      />

      <section className="bg-white py-24 sm:py-32">
        <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img src={FOUNDER_PHOTO} alt={BRAND.founder} className="w-full h-full object-cover" />
            </div>
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="border-l-2 border-gold pl-4">
                <div className="font-display font-extrabold text-3xl text-navy">20+</div>
                <div className="text-xs text-slate-brand mt-1">Years experience</div>
              </div>
              <div className="border-l-2 border-emerald-brand pl-4">
                <div className="font-display font-extrabold text-3xl text-navy">12</div>
                <div className="text-xs text-slate-brand mt-1">States operated</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="overline text-emerald-brand">Founder&apos;s Message</div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy mt-4 leading-[1.05]">
              &ldquo;Consultancy is a contract of <span className="text-emerald-brand">trust</span> — and we honour ours with engineering discipline.&rdquo;
            </h2>
            <div className="mt-10 relative pl-8 space-y-5 text-base sm:text-lg text-slate-brand leading-relaxed">
              <Quote className="absolute -left-1 top-0 text-gold" size={28} />
              <p>
                NEPHRC was born out of a conviction — that the next decade of India&apos;s infrastructure, hospitality and retail growth deserves consultancy partners who do more than draw plans. They engineer outcomes, hold themselves accountable, and remain transparent through every milestone.
              </p>
              <p>
                Over the past 20 years, our team has had the privilege of advising governments, hospitality sponsors, retail operators and cultural institutions across India. Each commission has reinforced our belief that discipline, multidisciplinary collaboration and an unrelenting client-first orientation are the foundations of consultancy worth choosing.
              </p>
              <p>
                Whether you are commissioning a corridor, a resort, a retail destination or a cultural landmark — our promise to you is simple: we will engineer the outcome you envisioned, and we will own it from feasibility to commissioning.
              </p>
              <div className="pt-4">
                <div className="font-display font-bold text-navy text-xl">— T G Dey</div>
                <div className="text-xs text-slate-brand mt-1">Founder &amp; Managing Director, NEPHRC</div>
              </div>
            </div>

            <div className="mt-12 grid sm:grid-cols-3 gap-px bg-slate-200">
              {ACHIEVEMENTS.map((a) => {
                const Icon = a.icon;
                return (
                  <div key={a.label} className="bg-white p-6">
                    <Icon className="text-gold" size={22} />
                    <p className="mt-4 text-sm text-slate-brand leading-relaxed">{a.label}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
